
import { FileText, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import HubspotIcon from "./icons/HubspotIcon";

const Footer = () => {
  return (
    <>
      <div className="h-1 bg-orange-500 w-full mt-auto"></div>
      <footer className="bg-[#000000e6] text-white py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6">
            <div className="flex items-center gap-3">
              <img 
                src="https://statics.myclickfunnels.com/workspace/vMBPdQ/image/11145350/file/2f67b6e6071658013889c941413177ba.png" 
                alt="Revenue Hub Logo" 
                className="h-8 object-contain" // Changed from h-10 to h-8 to match header
              />
              <span className="text-sm font-medium">AUTOMATIZA TU CRECIMIENTO</span>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6">
              <Link 
                to="/terms-and-conditions" 
                className="flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors"
              >
                <FileText className="h-4 w-4" />
                Términos y Condiciones
              </Link>

              <a 
                href="https://www.revenuehublatam.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors"
              >
                <ExternalLink className="h-4 w-4" />
                Sitio Web Revenue Hub
              </a>
            </div>

            <a 
              href="https://app.hubspot.com/ecosystem/22781597/marketplace/solutions/digitalgrowth" 
              target="_blank" 
              rel="noopener noreferrer"
              title="Revenue Hub es Partner Platinum de Hubspot"
            >
              <HubspotIcon size={40} />
            </a>
          </div>

          <div className="border-t border-gray-800 pt-4">
            <p className="text-sm text-gray-400 text-center">
              El método FocusFlow para aumentar tus ventas y esta interfaz de trabajo es propiedad intelectual de Revenue Hub Consulting SPA 2025.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
